import { Injectable } from '@angular/core';
import { DOMStorageField } from '../classes/dom-storage';

// prettier-ignore
@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  public readonly selectedUser  = new DOMStorageField('USER_ID',                sessionStorage);
  public readonly locale        = new DOMStorageField('locale',                 sessionStorage);
  public readonly lastSignIn    = new DOMStorageField('USER_LAST_SIGN_IN_TIME', sessionStorage);
}
